export default __webpack_public_path__ + "f107ff1d4bc5fcbe83124ea2f7f92a2c.jpg";